import styled from 'styled-components';

import { Link as VersionedRouterLink } from 'components/RouterLink';
import { linkStyles } from 'theme';

export const RouterLink = styled(VersionedRouterLink)`
  ${linkStyles}
`;
